module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('social-sharing', {
    attrs: {
      "url": _vm.url,
      "title": _vm.$t(_vm.title),
      "description": _vm.$t(_vm.description),
      "quote": _vm.$t(_vm.description),
      "hashtags": _vm.$t(_vm.hashtags),
      "twitter-user": _vm.$t(_vm.outTwitterUser)
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "container",
            staticStyle: {
              "margin-top": "2em",
              "width": "14em"
            }
          }, [_c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid #fff",
              "background-color": "#3b5998"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#55acee"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#4dc247"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#dd4b39"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#cb2027"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fa fa-pinterest",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#007bb5"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-linkedin",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#ff4500"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#45668e"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('i', {
            staticClass: "fa fa-vk",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])])])])
        
      },
      staticRenderFns: []
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac80535"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 302
// module chunks = 1